import { Box } from "@mui/material";
import { LegalDocumentViewer } from "../../components/legal-document-viewer";
import { copyrightTrademarkContent } from "./content";

export const CopyrightTrademarkPage = () => {
  return (
    <Box className="page copyright-trademark-page">
      <LegalDocumentViewer documentContent={copyrightTrademarkContent} />
    </Box>
  );
};
